export const setCookie = (c_name, value, expiredays) => {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    value +
    (expiredays == null ? "" : ";expires=" + exdate.toUTCString());
};
